import ConfigurationProvider from "./Configuration.provider";

export default ConfigurationProvider;
